import { AppBar, Toolbar, Button, Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState, useEffect } from 'react';
import { languages, useLanguage, setLanguage } from '../../data/languages';

function Header() {
  const currentLang = useLanguage(); // 响应式语言状态
  const config = languages[currentLang] || languages['en']; // 获取当前语言配置，带fallback

  const handleLanguageChange = (_, newLang) => { // 处理语言切换
    if (newLang) {
      setLanguage(newLang); // 触发响应式更新，无需重载
    }
  };

  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ backdropFilter: 'blur(5px)', zIndex: 1 }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>


      </Toolbar>
    </AppBar>
  );
}

export default Header; 